import PropTypes from "prop-types";

import { FallBackImage, Modal } from "@dpdgroupuk/mydpd-ui";

import styles from "./MapViewModal.module.scss";

export const MapViewModal = ({ src, show, onClose }) => {
  return (
    <Modal show={show} onHide={onClose}>
      <div className={styles.container}>
        <Modal.Header variant="brand" closeButton>
          Map View
        </Modal.Header>
        <Modal.Body className={styles.content}>
          <FallBackImage className={styles.img} src={src} />
        </Modal.Body>
      </div>
    </Modal>
  );
};

MapViewModal.propTypes = {
  src: PropTypes.string,
  show: PropTypes.bool,
  onClose: PropTypes.func,
};
